import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { Board, RightsholderBoard } from 'src/core/Models/rightsholder-board.model';
import { RightsholdersResponse } from 'src/core/Models/rightsholders-response';

// Add these interfaces
interface RightsholderBoardItem {
  rightsholderId: number;
  rightsholderName: string;
  parentRightsholderId: number | null;
  parentRightsholderName: string | null;
  labelType: string;
  repertoireAccessLevelId: number;
  boardId: string;
  createdAt: string;
}

interface RightsholderBoardResponse {
  items: RightsholderBoardItem[];
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

interface ParentRightsholder {
  rightsholderId: number;
  rightsholderName: string;
}

@Injectable({
  providedIn: 'root',
})

export class RightsholderBoardService {
  private baseRightsholderBoardUrl = AppConfig.settings.apiServer.managementServiceUrl + '/Board';
  constructor(private http: HttpClient) { }

  insertRightsholderBoard(board: RightsholderBoard) {
    return this.http.post<RightsholderBoard>(`${this.baseRightsholderBoardUrl}/CreateRightsholderBoard`, board);
  }

  updateRightsholderBoard(board: RightsholderBoard) {
    return this.http.patch<RightsholderBoard>(`${this.baseRightsholderBoardUrl}/UpdateRightsholderBoard`, board);
  }

  searchBoards(organizationId: string, title: string) {
    return this.http.get<Board[]>(`${this.baseRightsholderBoardUrl}/SearchBoards?organizationId=${organizationId}&title=${title}`);
  }

  deleteRightsholderBoard(boardId: string) {
    return this.http.delete(`${this.baseRightsholderBoardUrl}/DeleteRightsholderBoard/${boardId}`);
  }

  getUserRightsholderBoards(userId: string, organizationId: string, pageIndex: number, pageSize: number, name?: string) {
    const url = `${this.baseRightsholderBoardUrl}/GetUserRightsholderBoards?userId=${userId}&organizationId=${organizationId}&pageIndex=${pageIndex}&pageSize=${pageSize}${name ? `&name=${name}` : ''}`;
    return this.http.get<RightsholderBoardResponse>(url);
  }

  getParentRightsholders(organizationId: string) {
    const url = `${this.baseRightsholderBoardUrl}/GetParentRightsholders?organizationId=${organizationId}`;
    return this.http.get<ParentRightsholder>(url);
  }

  getRightsholders(organizationId: number, pageIndex: number, pageSize: number, searchKeyword?: string) {
    const url = `${this.baseRightsholderBoardUrl}/GetRightsholders?organizationId=${organizationId}&pageIndex=${pageIndex}&pageSize=${pageSize}${searchKeyword ? `&searchKeyword=${searchKeyword}` : ''}`;
    return this.http.get<RightsholdersResponse>(url);
  }
}
